
  
function getSafra2(){
    var $select = $('#selecsafra2');
    var safra = $select.val();

    return safra;
}


function montaGrafDespesasExec(ling){

    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
       
            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafdesp').getContext('2d');

            var mapa = new Map();

            var tamanho = tipoetapa.length;
            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(mapa.has(label)===true){
                    var temp = mapa.get(label) + val;
                    mapa.set(label, temp);
                }
                else{
                    mapa.set(label, val);
                }
            }

            var vlabels = []; var vdatas = [];
            var kv;
            for ( kv in mapa.entries()) {
                key = kv[0];
                value = kv[1];
                vlabels.push(key);
                vdatas.push(value);
                console.log(key + " = " + value);
            }

            var labelValor; var labelTexto;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Despesas";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Gastos";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Output";
            } 


            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdatas,
                    label: labelValor,
                    borderColor: "#ff0000",
                    fill: true
                    }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
        }
    });
   
}

function montaGrafReceitasExec(ling){

    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");
    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {

            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafrec').getContext('2d');

            var mapa = new Map();

            var tamanho = tipoetapa.length;
            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(mapa.has(label)===true){
                    var temp = mapa.get(label) + val;
                    mapa.set(label, temp);
                }
                else{
                    mapa.set(label, val);
                }
            }

            var vlabels = []; var vdatas = [];
            var kv;
            for (var kv in mapa.entries()) {
                key = kv[0];
                value = kv[1];
                
                vlabels.push(key);
                vdatas.push(value);
                console.log(key + " = " + value);
            }

            var labelValor; var labelTexto;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Receita";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Rendimiento";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Income";
            } 

            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdatas,
                    label: labelValor,
                    borderColor: "#43b534",
                    fill: true
                    }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
        }
    });
   
}

function montaGrafDespesasEtapasExec(ling){
    
    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });


            var mapa = new Map();

            var tamanho = tipoetapa.length;
            var vdatas = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                vdatas[etapas.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafdespetapa').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var labelEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Despesas Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Gastos por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Output By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
            } 


            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label: labelValor,
                        backgroundColor: '#42d4f4', 
                        data: vdatas,
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    },
                    scales: {
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });

        }
    });
}

function montaGrafReceitasEtapasExec(ling){
    
    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            
            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });


            var mapa = new Map();

            var tamanho = tipoetapa.length;
            var vdatas = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                vdatas[etapas.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafrecetapa').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var labelEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Receita Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Rendimiento por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Income By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
            } 

            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label: labelValor,
                        backgroundColor: '#7d5bb7', 
                        data: vdatas,
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    },

                    scales: {
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });
        }
    });
}

function DistribuicaoTerceirizadoExec(ling){
    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
 
            valor = json.map(function(item) {
                return item.valorservico;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            tiporesponsavel = json.map(function(item) {
                return item.tiporesponsavel;
            });


            var totalterc = 0;
            var totalnaoterc = 0;

            var tamanho = tiporesponsavel.length;
            for(i=0; i<tamanho; i++){
                if(etapas.indexOf(tipoetapa[i])==-1) continue;
                if(fluxo[i] === 'receita') continue;

                if(tiporesponsavel[i] === 'terceirizado'){
                    totalterc = totalterc + valor[i];
                }
                else{
                    totalnaoterc = totalnaoterc + valor[i];
                }
            }

            var ctx = document.getElementById('grafdistribterc').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var lblEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Distribuição da Terceirização";
                vlabels = ["terceirizado", "não-terceirizado"];
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Distribución de la Tercerización";
                vlabels = ["Tercerizado", "No-tercerizado"];
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Outsourcing Distribution";
                vlabels = ["outsourced", "not outsourced"];
            } 
            
            var chart = new Chart(ctx, {
                type: 'pie',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label: labelValor,
                        backgroundColor: ['#c45307', '#edba97'],
                        data: [totalterc, totalnaoterc]
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    }               
                }
            });
        }   
    });
}

function linguagemexec(){

    var urlJSON = '/api/account/';
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {      
            var linguagem = json.langKey;

            if(linguagem==="pt-br"){
                montaRelatorioExec('pt');
            }
            else if(linguagem==="en"){
                montaRelatorioExec('en');
            }
            else{
                montaRelatorioExec('es');
            }
        }
    });
}

function montaRelatorioExec(ling){
    var urlJSON = '/api/account/';
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            if(ling==="pt"){
                $('#titulodespexec').html("Despesas ao Longo do Tempo");
                $('#titulorecexec').html("Receita ao Longo do Tempo");
                $('#titulodespexecetapa').html("Despesas por Etapa");
                $('#titulorecexecetapa').html("Receita por Etapa");
                $('#titulodistribexec').html("Distribuição dos Gastos Por Terceirizados");
            }
            else if(ling === 'en'){
                $('#titulodespexec').html("Output Over Time");
                $('#titulorecexec').html("Income Over Time");
                $('#titulodespexecetapa').html("Output By Stage");
                $('#titulorecexecetapa').html("Income By Stage");
                $('#titulodistribexec').html("Distribution By Outsourcing");
            }
            else if(ling==="es"){
                $('#titulodespexec').html("Costes a lo largo del tiempo");
                $('#titulorecexec').html("Rendimiento a lo largo del tiempo");
                $('#titulodespexecetapa').html("Costes por Etapas");
                $('#titulorecexecetapa').html("Rendimiento por Etapas");
                $('#titulodistribexec').html("Distribución por Tercerización");
            
            }
            montaGrafDespesasExec(ling);
            montaGrafReceitasExec(ling);
            montaGrafDespesasEtapasExec(ling);
            montaGrafReceitasEtapasExec(ling);
            DistribuicaoTerceirizadoExec(ling);
        }
    });
}